<template>
    <div id="gallery_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerHeader2">Upload Media</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content customer-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="needs-validation" novalidate id="GalleryForm">
                                <div class="form-row">
                                    <div class="col-4 form-group">
                                        <div class="d-flex justify-content-between">
                                            <label class="control-label require" for="media_title">Media Title</label>
                                            <span style="font-size: 14px;">{{ media_title_count }}/100</span>
                                        </div>
                                        <input type="text" class="form-control" v-model.trim="media_title"
                                            id="media_title" placeholder="Media Title" name="media_title">
                                        <span class="field-error ml-0">{{ media_title_error_msg }}</span>
                                    </div>
                                </div>
                                <DropZone 
                                    :showUploadedFiles="dropZonePreviewFiles.length > 0 && isEdit"
                                    :maxFileLimit='10'
                                    :docErrorMsg="doc_error_msg"
                                    :dropzoneLabel="'Upload Media'"
                                    :dropzoneRequired="dropZonePreviewFiles.length == 0"
                                    :dropZonePreviewFiles="dropZonePreviewFiles"
                                    :acceptedFiles="'.jpg, .jpeg, .png, .webp, .mp4, .mkv, .avi, .webm, .ogv'"
                                    :noteBelowDropzone="'A maximum of 10 files can be uploaded at a time.'"
                                    :isEdit="isEdit"
                                    @dropzone-update-files="updateFiles"
                                    @dropzone-remove-files="removeFiles"
                                />
                                <div class="btn-groups">
                                    <button v-if="isEdit" type="submit" id="CreatePublicationBtn"
                                        class="btn btn-primary" v-on:click.prevent="SaveMedias()">
                                        <i class="fp-save"> </i> Update
                                    </button>
                                    <button v-else type="submit" id="CreatePublicationBtn" class="btn btn-primary"
                                        v-on:click.prevent="SaveMedias()">
                                        <i class="fp-save"> </i> Save
                                    </button>
                                    <button type="submit" id="cancelPublicationBtn" class="btn btn-tertiary"
                                        v-on:click.prevent="goPreviousPath">
                                        <i class="fp-close"> </i> Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import { commonMixins } from '../../mixins/commonMixins';
import { contractMixins } from '../../mixins/contractMixins';
import DropZone from '../DropZone.vue';

export default {
    name: "GalleryCreate",
    components: {
        DropZone,
    },
    metaInfo() {
        return {
            title: "Upload Media | " + process.env.COPYRIGHT_NAME
        }
    },

    mixins: [commonMixins, contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading: false,
        dropZonePreviewFiles: [],
        doc_error_msg: "",
        files: [],
        media_title: '',
        media_title_count: 0,
        media_title_error_msg: '',
        isEdit: false,
        galleryId: 0,
        removedFiles: []
    }),

    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_create_media') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
        media_title(newValue) {
            if (newValue.length > 100) {
                this.media_title = newValue.substring(0, 100);
            }
            this.media_title_count = newValue.length;
        }
    },
    mounted: function () {
        var self = this;
        self.getPermissions();

        if (
            self.$route.params.id !== undefined
            &&
            self.$route.params.id > 0
        ) {
            self.galleryId = self.$route.params.id;
            self.isEdit = true;
            self.loadSingleItem();
        }
    },
    methods: {
        updateFiles(files) {
            this.files = files;
        },
        removeFiles(removedFiles) {
            this.removedFiles = removedFiles;            
        },
        validateFields() {
            var error = false;
            if (this.dropZonePreviewFiles.length == 0) {
                if (this.files.length == 0) {
                    this.doc_error_msg = "Media File is Required";
                    error = true;
                }
            }
            if (this.media_title == '' || this.media_title == null) {
                this.media_title_error_msg = "Media Title is Required";
                error = true;
            }
            return error;
        },
        SaveMedias() {
            var self = this;
            var error = self.validateFields();
            
            if (!error) {
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/media-gallery/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        gallery_id: self.galleryId,
                        title: self.media_title,
                        docs: self.files,
                        removed_files: self.removedFiles
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == 'success') {
                            self.$router.push("/media-gallery/list");
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, false, 'save-media-gallery');
                    }
                });
            }
        },
        loadSingleItem() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/media-gallery/" + self.galleryId,
                type: "GET",
                headers: self.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.code == 200) {
                        self.media_title = data.content.title;
                        self.dropZonePreviewFiles = data.content.file_path;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'load-single-gallery-item');
                }
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/gallery/GalleryCreate.vue